import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import ButtonComp from '../Button/buttonComp';
import style from './breadCrumb.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  setFutureRoute,
  setShowModal,
} from '../../state/slice/saveProgressSlice';

const Breadcrumb = ({
  paths,
  buttonOnclick,
  buttonName,
  disable = false,
  linkDisable = false,
}) => {
  const navigate = useNavigate();
  const isFormDirty = useSelector(state => state.saveProgress.isFormDirty);

  const dispatch = useDispatch();
  // Function to handle navigation
  const handleClick = (event, path) => {
    event.preventDefault();
    if (isFormDirty) {
      dispatch(setShowModal(true));
      dispatch(setFutureRoute(path));

      return;
    }
    navigate(path);
  };

  // function toTitleCase(str) {
  //   return str
  //     .replace(/[-/]/g, ' ') // Replace slashes and hyphens with spaces
  //     .split(/\s+/) // Split by any whitespace
  //     .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter of each word
  //     .join(' '); // Join back into a single string with spaces
  // }

  return (
    <Box
      className={`text-bold-18px ${style.breadCrumbContainer}`}
      sx={{
        display: { xs: 'block', md: 'flex' },
        height: { xs: 'auto', md: '60px' },
      }}>
      <Breadcrumbs aria-label="breadcrumb" separator="/">
        {paths.map((path, index) => {
          const isLast = index === paths.length - 1;

          // If there's only one link, display it as text
          if (paths.length === 1) {
            return (
              <Box
                key={index}
                className={`semitext-bold-18px ${style.box_color}`}>
                {paths[0].name}
              </Box>
            );
          }
          // Highlight current link
          if (isLast) {
            return (
              <Box
                className="semitext-bold-18px"
                key={path.link}
                color="#F37021">
                {path.name}
              </Box>
            );
          } else {
            // Render previous links that navigate to the corresponding path
            return (
              <div className="semitext-bold-18px" key={path.link}>
                <Link
                  color={'#322E56'}
                  underline="hover"
                  href={!linkDisable && path.link}
                  onClick={
                    linkDisable
                      ? () => { }
                      : event => handleClick(event, path.link)
                  }>
                  {path.name}
                </Link>
              </div>
            );
          }
        })}
      </Breadcrumbs>
      {buttonOnclick && (
        <Grid item sx={{ marginTop: { xs: '8px', md: 0 } }}>
          <ButtonComp
            className="text-bold-14px"
            value={buttonName}
            gradient="linear-gradient(168deg, #F37021 -13.5%, #FDBA12 119.9%)"
            height="36px"
            width="160px"
            textcolor="#ffff"
            borderRadius="8px"
            disabled={disable}
            onClick={() => buttonOnclick()}
          />
        </Grid>
      )}
    </Box>
  );
};

Breadcrumb.propTypes = {
  paths: PropTypes.array.isRequired,
  buttonOnclick: PropTypes.func,
  buttonName: PropTypes.string,
  disable: PropTypes.any,
  linkDisable: PropTypes.any,
};

export default Breadcrumb;
